import React from "react";
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import checked_icon from "../../../images/gameplay_ui/icons/create_train/checked_icon.svg";
import unchecked_icon from "../../../images/gameplay_ui/icons/create_train/unchecked_icon.svg";
import is_break_down from "../../../images/gameplay_ui/icons/is_break_down.svg";
import steamIcon from "../../../images/gameplay_ui/icons/heat icon.svg";
import electroIcon from "../../../images/gameplay_ui/icons/electro icon.svg";
import electroPic from "../../../images/gameplay_ui/illustrations/electro_pic.png";
import steamPic from "../../../images/gameplay_ui/illustrations/steam_pic.png";
import is_repairing_icon from "../../../images/gameplay_ui/icons/repair/repair in-progress.svg"
import {LOCO_TYPE} from "../../../constants/Constants";
import {LOCO_HEADER_COLOR} from "../GameStyleUI";
import StateBar from "../StateBar";
import GameData from "../../../gameplay/model/GameData";
import agent from "../../../agent";
export default class LocoPopupCard extends React.Component {
    onCardClick(e) {
        e.stopPropagation();
        if (this.props.onClick) {
            this.props.onClick(this.props.loco);
        }
    }

    render() {
        let mainStyle = {
            position: "relative",
            width: "100px",
            height: "149px"
        }
        let imageStyle = {
            width: "90px",
            height: "90px"
        }
        let insideCardStyle = {
            position: "relative",
            padding: "5px",
            height: "112px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between"
        }
        let bottomStyle = {
            display: "flex",
            justifyContent: "space-between"
        }

        let isLoco = this.props.loco.partsType === LOCO_TYPE;

        let colors = LOCO_HEADER_COLOR[this.props.loco.partsType];
        let content = [];
        content.push(<img key={'img'} alt={'loco'} style={imageStyle} src={isLoco ? steamPic : electroPic}/>);

        let isHot = this.props.loco.isHot;
        if (this.props.canSetHot && !this.props.loco.isBreakDown && (GameData.CurrentGame.state === 4 || GameData.CurrentGame.state === 5)) {

            let hotTrain = {
                position: "absolute",
                display: "flex",
                justifyContent: "start",
                alignItems: "center",
                height: "20px",
                width: "90px",
                top: "75px",
                background: "rgba(0, 0, 0, 0.5)",
                borderRadius: "0px 0px 5px 5px"
            }
            let hotTrainText = {
                fontSize: "10px",
                lineHeight: "10px",
                fontWeight: "bold",
                paddingLeft: "5px",
                color: "white",
                verticalAlign: "middle",
                textTransform: "uppercase"
            }
            content.push(<div style={hotTrain} key={'loco'} onClick={e => {

                e.stopPropagation();
                if(GameData.CurrentGame.state === 5){
                    console.log(this.props.loco)
                   agent.GamePlay.setLocoHot(this.props.teamID,{
                       'id':  this.props.loco.id
                   }, ()=>{

                   })
                }
                this.props.loco.isHot = !this.props.loco.isHot;
                this.props.parent?.forceUpdate();
                this.forceUpdate();
            }}>
                {this.props.canSetHot ? <img alt={'check'} style={{paddingLeft: "5px", paddingRight: "5px"}}
                                             src={isHot ? checked_icon : unchecked_icon}/> : ""}
                <div style={hotTrainText}>{
                    isHot ? "ведущий" : "холодный"
                }</div>
            </div>);
        }


        content.push(<div key={'state'} style={bottomStyle}>
            <StateBar state={this.props.loco.state} scale={1.5}/>
            {this.props.loco.isBreakDown ? <img alt={"icon"} src={is_break_down}/> : ""}
        </div>)
        if (this.props.loco.isReparing) {
            let repairingStyle = {
                position: "absolute",
                left: "0",
                top: "-25px",
                width: "100px",
                height: "149px",
                background: "rgba(3, 3, 3, 0.2)",
                borderRadius: "0px"
            }
            content.push(<div key={'icon'} style={repairingStyle}>
                <img alt={"icon"} src={is_repairing_icon}/>
            </div>)
        }
        content = <div style={insideCardStyle}>{content}</div>

        let badgeStyle = {
            position: "absolute",
            zIndex: 1,
            background: "white",
            borderRadius: "3px",
            padding: "5px 5px 3px",
            right: 0,
            fontSize: "12px",
            fontWeight: "bold",
            boxShadow: "-4px 4px 6px -3px rgb(0 0 0 / 30%)",
            pointerEvents: "none"
        };
        let rentedIds = GameData.CurrentGame.rentLocoContract.map(el => el.locoId);

        return <div style={{
            ...mainStyle,
            ...this.props.style
        }}>
            <GameWindowHeader width={100}
                              height={26}
                              icon={isLoco ? steamIcon : electroIcon}
                              title={(isLoco ? "Тепловоз" : "Электровоз")}
                              iconSize={16}
                              fontSize={10}
                              fontWeight={"bold"}
                              positionTop={8}
                              positionLeft={0}
                              colorStart={colors[0]}
                              colorEnd={colors[1]}
            />
            {rentedIds.includes(this.props.loco.id) &&
            <div style={badgeStyle} className={"rentId"}>{this.props.loco.id}</div>}
            <GameWindowBg width={100} height={123} value={content} onClick={this.onCardClick.bind(this)}/>
        </div>;
    }
}
